import axios from "axios";
import { registerData } from "../i18n/data";
import { markSessionReplaced } from "./session";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const http = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Global 401 handler: clear session and redirect to /login
// (skipped for endpoints that legitimately return 401 to drive UX, like /auth/me before login)
const NO_REDIRECT_PATHS = ["/auth/login", "/auth/me", "/auth/forgot-password", "/auth/reset-password", "/agent-app/me", "/agent-app/login"];

http.interceptors.response.use(
  (r) => { if (localStorage.getItem("xaltix_locale")?.includes('"en"') && r.data && typeof r.data === "object") registerData(r.data); return r; },
  (err) => {
    const status = err?.response?.status;
    const url = err?.config?.url || "";
    if (status === 401 && err?.response?.data?.detail === "SESSION_REPLACED") {
      const p = window.location.pathname;
      if (!p.startsWith("/agent") && !p.startsWith("/login") && !p.startsWith("/e/")) { markSessionReplaced(); return new Promise(() => {}); }
    }
    if (status === 401 && !NO_REDIRECT_PATHS.some((p) => url.includes(p))) {
      const path = window.location.pathname;
      const onAgent = path.startsWith("/agent") || path.startsWith("/pcs");
      if (onAgent && (url.includes("/agent-app/") || url.includes("/pcs/"))) window.dispatchEvent(new CustomEvent("agent-session-ended", { detail: err?.response?.data?.detail }));
      const onAuth = path === "/login" || path === "/forgot-password" || path === "/reset-password";
      if (!onAgent && !onAuth) {
        window.location.assign("/login");
        return new Promise(() => {}); // never resolves: React stops rendering further
      }
    }
    if (status === 403 && err?.response?.data?.detail?.code === "delete_restricted" && deletionHost) {
      return new Promise((resolve) => deletionHost({ path: `${url}${err.config?.params ? `?${new URLSearchParams(err.config.params)}` : ""}`, resolve: () => resolve({ data: { requested: true } }), cancel: () => resolve({ data: { cancelled: true } }) }));
    }
    return Promise.reject(err);
  }
);

let deletionHost = null;
export const registerDeletionHost = (fn) => { deletionHost = fn; };
let primaryAdmin = false;
export const setPrimaryAdmin = (v) => { primaryAdmin = !!v; };
export const askDelete = (msg) => (primaryAdmin ? window.confirm(msg) : true);
export const delTitle = () => (primaryAdmin ? "Supprimer" : "Demander la suppression");

export function formatApiError(err) {
  const d = err?.response?.data?.detail;
  if (d == null) {
    if (err?.isAxiosError && !err.response) return "Connexion au serveur impossible — vérifiez votre réseau puis réessayez.";
    return err?.message || "Erreur inconnue";
  }
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => (typeof e?.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (typeof d?.msg === "string") return d.msg;
  if (typeof d?.message === "string") return d.message;
  return String(d);
}
